export default __webpack_public_path__ + "static/main4-480-220f217e4ce969394b616a9d515102e2.png";